import React, { FC } from 'react'

import { mainColors } from '../../styles'
import { formatNumber } from '../../utils'
import { getRatingPercentageColor } from '../RatingBar/RatingBar.utils'
import * as S from './NPSRating.styles'

interface NpsRatingProps {
  value?: number
}

export const NPSRating: FC<NpsRatingProps> = ({ value }) => {
  if (value == null) {
    return <S.NPSRating color={mainColors.neutralExtraDark}>-</S.NPSRating>
  }

  const currentNPSRating = formatNumber(value)
  const npsColor = getRatingPercentageColor(value)

  return <S.NPSRating color={npsColor}>{currentNPSRating}</S.NPSRating>
}
